import React, { useEffect, useState, createContext, useContext } from 'react';
interface AdminContextType {
  isAuthenticated: boolean;
  user: {
    name: string;
    email: string;
    role: string;
  } | null;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
}
const AdminContext = createContext<AdminContextType | undefined>(undefined);
export const AdminProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<{
    name: string;
    email: string;
    role: string;
  } | null>(null);
  // Check local storage on mount
  useEffect(() => {
    const storedAuth = localStorage.getItem('adminAuth');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
      setUser({
        name: 'Super Admin',
        email: 'admin@igs.edu.ng',
        role: 'Super Admin'
      });
    }
  }, []);
  const login = async (email: string, password: string): Promise<boolean> => {
    // Simulate API call
    return new Promise(resolve => {
      setTimeout(() => {
        if (email === 'admin@igs.edu.ng' && password === 'admin2026') {
          setIsAuthenticated(true);
          setUser({
            name: 'Super Admin',
            email: 'admin@igs.edu.ng',
            role: 'Super Admin'
          });
          localStorage.setItem('adminAuth', 'true');
          resolve(true);
        } else {
          resolve(false);
        }
      }, 800);
    });
  };
  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('adminAuth');
  };
  return <AdminContext.Provider value={{
    isAuthenticated,
    user,
    login,
    logout
  }} data-id="element-663">
      {children}
    </AdminContext.Provider>;
};
export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};